import React from 'react'
import './call-to-action.css'
export default function CallToAction() {
  return (
    <div className='cta-container'>
        <h3>Ready to get started?</h3>
        <p>Join thousands already taking control with FinFlex. Get started today!</p>
        <button>Join the Waitlist</button>
    </div>
  )
}
